export default __webpack_public_path__ + "static/media/screenshot1.382550a3.jpg";